import axios from "axios";
import { getToken } from "./service";
import qs from "qs";
import Config from "../config";
import _ from "underscore";

export interface ProjectionScreenReport {
    coursewareTotalCount: number; //总课件数
    coursewareUnPublishCount: number; //未发布课件
    coursewarePublishCount: number; //已发布课件
    courseWareCount: number; //总课件数
    wareDocumentCount: number; //课件文档数
    wareVideoCount: number; //课件视频数
    topicCount: number; //发布题目数
    objectiveCount: number; //客观题目数
    subjectiveCount: number; //主观题目数
    signInCount: number; //发起签到数
    signInParticipation: string; //出勤率
    randomCount: number; //随机选人数
    titleCount: number; //标签语数
    voteCount: number; //发起投票数
    voteParticipation: string; //投票参与率
    paperCount: number; //发布作业数
    paperParticipation: string; //作业参与率
    exerciseCount: number; //发布练习数
    exerciseParticipation: string; //练习参与率
    groupTaskCount: number; //小组任务数
    groupTaskParticipation: string; //小组任务参与率
    chapterCount: number; //章节内容数
    chapterVideoCount: number; //章节内容视频数
    chapterDocumentCount: number; //章节内容文档数
    chapterOtherCount: number; //章节内容其他资料数
    classHour: number; //周学时
    onlineQueCount: number; //直播问卷数
    onlineQuePercent: string; //直播问卷参与率
    liveCount: number; //直播次数
    livePercent: string; //直播参与率
    questionnaireCount: number; //问卷数量
    questionnaireParticipation: string; //问卷参与率
}

/**
 * 课堂报告
 * @param weekTimeId
 */
interface ScreenProps {
    courseNo: string;
    courseSeq: string;
    batchNo: string | undefined;
    customerCode: string;
    weekTimeId: number;
}
export function getProjectionScreenReport(data: ScreenProps) {
    const token = getToken();
    return axios
        .post<SuccessData<ProjectionScreenReport>>(
            `/teacher/classReport/getProjectionScreenReport`,
            qs.stringify(data),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 教学分析
 */

export function getTeachingInfos(courseNo: string, courseSeq: string) {
    const token = getToken();
    return axios
        .post<SuccessData<ProjectionScreenReport>>(
            `/teacher/classReport/getTeachingInfos`,
            qs.stringify({ courseNo, courseSeq }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

interface MarkInfo {
    id: number; //标签ID
    mark: string; //标签
}

interface StudentInfo {
    studentName: string;
    studentNo: string;
}

export interface LearningInfo {
    index: number;
    key: string;
    studentInfo: StudentInfo;
    studentNo: string; //学号
    studentName: string; //学生姓名
    department: string; //学院
    subject: string; //专业
    className: string; //班级
    coursewarePublishCount: number; //发布课件数
    studyCoursewareCount: number; //课件参与数
    signInCount: number; //教师发起总签到数
    signInNormalCount: number; //正常签到数
    signInLateCount: number; //迟到数
    signInEarlyCount: number; //早退数
    signAskForLeaveCount: number; //请假数
    signAskForLeaveCounts: number; //请假数
    votePaperCount: number; //教师发起投票数
    votePaperJoinCount: number; //参与投票数
    markList: MarkInfo[]; //标签
    paperCount: number; //教师发起作业数
    paperJoinCount: number; //作业参与数
    paperAveScore: number; //作业平均分
    exerciseCount: number; //发布练习数
    exerciseJoinCount: number; //练习参与数
    exerciseAvgCount: number; //练习平均分
    groupTaskCount: number; //发起小组活动数
    groupTaskParticipation: string; //参与小组活动率
    groupTaskAvgCount: number; //小组活动平均分
    markItem: string;
}

/**
 * 学情分析
 */

export function getLearningInfos(courseNo: string, courseSeq: string) {
    const token = getToken();
    return axios
        .post<SuccessData<LearningInfo[]>>(
            `/teacher/classReport/getLearningInfos`,
            qs.stringify({ courseNo, courseSeq }),
            { headers: { token } }
        )
        .then(res => res.data.data)
        .then(data => {
            return data.map((item, index) => ({
                ...item,
                index: index + 1,
                key: _.uniqueId(`${_.now()}_`),
                studentInfo: {
                    studentName: item.studentName,
                    studentNo: item.studentNo
                },
                markItem: item.markList.map(mark => mark.mark).join(";")
            }));
        });
}

/**
 * 导出学情分析
 * @param courseNo
 * @param courseSeq
 * @param orderBy
 */
export function exportLearningInfo(
    courseNo: string,
    courseSeq: string,
    orderBy: string,
    batchNo: string
) {
    const token = getToken();
    window.open(
        `${
            Config.ApiHost
        }teacher/classReport/exportLearningInfo?courseNo=${courseNo}&batchNo=${batchNo}&courseSeq=${courseSeq}&orderBy=${orderBy}&token=${encodeURIComponent(
            token!
        )}`
    );
}
export enum studyPageLine {
    line = 8
}
